import React from 'react';
import ReviewStarSummary from "./ReviewStarSummary";
import ReviewCharacteristicsSummary from "./ReviewCharacteristicsSummary";
import {ReviewService} from "../../../services/api/ReviewService";
import {handicaddieSelector} from "../../../services/store/asyncThunk";
import {Spinner} from "react-bootstrap";

interface Props {

}

const ReviewStatistics = ({}: Props) => {

    // const [stats, setStats] = useState<ReviewSearchStatisticsResource>();
    // const [errMsg, setErrMsg] = useState<string>();
    // const [loading, setLoading] = useState<boolean>(false);

    const { searchStatistics } = ReviewService()
    const { selectedClub } = handicaddieSelector((state) => state.clubs)
    const { stats } = handicaddieSelector((state) => state.review)

    // useEffect(() => {
    //     if (!selectedClub) {
    //         return;
    //     }
    //
    //     loadStats()
    // }, [selectedClub])

    // const loadStats = async () => {
    //     if (!selectedClub || loading) {
    //         return;
    //     }
    //
    //     setErrMsg(undefined);
    //     setLoading(true);
    //
    //     let resp = await searchStatistics({
    //         clubId: selectedClub.id
    //     })
    //     setLoading(false);
    //     if (resp.error) {
    //         setErrMsg(resp.error.message);
    //         return;
    //     }
    //
    //     if (resp.statistics) {
    //         setStats(resp.statistics)
    //     }
    // }

    return (
        <div className="explorer-stats-container">
            <div className="explorer-stats-section explorer-stats-reviewStarSummary">
                {stats && <ReviewStarSummary stats={stats} />}
                {!stats && <Spinner animation='border' />}
            </div>
            <div className="explorer-stats-section">
                {stats && <ReviewCharacteristicsSummary stats={stats} />}
                {!stats && <Spinner animation='border' />}
            </div>
        </div>
    )
}

export default ReviewStatistics;